import type { GeofenceType } from '@cobliteam/common-types/src/geofenceV3';
import { GeofencesDef } from '@cobliteam/common-types/src/geofenceV3';
import Icon from '@cobliteam/ui/icons';
import {
  containedCompoundVariants,
  dotCompoundVariants,
  outlinedCompoundVariants,
  surfaceCompoundVariants,
  textVariants,
  variantVariants,
} from '@cobliteam/ui/theme/tokens/variants/sharedVariants';
import { tv, type VariantProps } from 'tailwind-variants';

const geofenceIconVariants = tv({
  base: 'flex items-center justify-center rounded-md',
  variants: {
    size: {
      sm: 'size-6',
      md: 'size-8',
      lg: 'size-10',
    },
    color: textVariants,
    variant: {
      ...variantVariants,
      icon: 'bg-transparent p-0',
    },
  },
  compoundVariants: [...containedCompoundVariants, ...outlinedCompoundVariants, ...surfaceCompoundVariants, ...dotCompoundVariants],
  defaultVariants: {
    size: 'md',
    variant: 'contained',
    color: 'primary',
  },
});

type GeofenceIconVariants = VariantProps<typeof geofenceIconVariants>;
interface GeofenceIconProps extends Omit<GeofenceIconVariants, 'color'> {
  type: GeofenceType;
  className?: string;
}

const GeofenceIcon = ({ type, size = 'md', variant = 'contained', className }: GeofenceIconProps) => {
  const { color, iconName, label } = GeofencesDef[type];

  const iconSizeClasses = {
    sm: 'size-3',
    md: 'size-4',
    lg: 'size-5',
  };

  return (
    <div className={geofenceIconVariants({ color, size, variant, className })} data-testid={`GeofenceIcon-${type}`}>
      <Icon name={iconName} className={iconSizeClasses[size]} />
      <span className='sr-only'>{label}</span>
    </div>
  );
};

export default GeofenceIcon;
